import "./App.css";
import "./DarkMode.css";
import KanbanComponent from "./Kanban/KanbanComponent";
import SideBarComponent from "./SideBar/SideBarComponent";
import React, { useEffect, useState } from "react";
import AddProjectComponent from "./SideBar/AddProjectComponent";
import LoginComponent from "./Login/LoginComponent";
import { deleteProjectById } from "./Services/UpdateProject";
import { getAllProjects } from "./Services/GetProjects";
import { addProject } from "./Services/AddProject";

/*
  Function named 'App' that contains a
  Page routing container.
*/

const App = () => {
  const [projects, setProjects] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [kanbanId, setKanbanId] = useState("");
  const [pOpen, setPOpen] = useState(false);
  const [prevElement, setPrev] = useState(null);
  const isDark = localStorage.getItem("isDark");

  // Code that runs while to component is mounted
  useEffect(() => {
    // Get all the available projects
    // call getAllProjects() function from
    // /Services/GetProjects.js
    setProjects(getAllProjects());
  }, []);

  const deleteProject = (e, id) => {
    e.stopPropagation();
    deleteProjectById(id);
    console.log(id + " for deletion");
    setProjects(getAllProjects());
  };

  const createProject = () => {
    addProject(projectName);
    setProjects(getAllProjects());
    setPOpen(false)
  };

  return (
    <>
      {localStorage.getItem("profile") ? (
        <main className={`app ${isDark ? "app-dark" : ""}`}>
          <div>
            <SideBarComponent
              isDark={isDark}
              handleChangeProject={(e) => {
                if (prevElement) {
                  prevElement.className = ` project-card ${
                    isDark ? "project-card-dark" : ""
                  }`;
                }
                e.target.className += `${
                  isDark
                    ? " project-card-selected-dark"
                    : " project-card-selected"
                }`;
                setKanbanId(e.target.id);
                console.log(e.target.className);
                setPrev(e.target);
              }}
              projects={projects}
              handleDeleteProject={(e, id) => deleteProject(e, id)}
              handleAddProject={() => setPOpen(true)}
            />
          </div>
          <div className="workspace">
            <KanbanComponent isDark={isDark} id={kanbanId} />
          </div>
        </main>
      ) : (
        <>
          <LoginComponent />
        </>
      )}

      <AddProjectComponent
        open={pOpen}
        isDark={isDark}
        onProjectNameChange={(e) => setProjectName(e.target.value)}
        onAddProject={createProject}
        onCancel={() => {
          setPOpen(false);
        }}
      />
    </>
  );
};

export default App;
